<template>
    <div>
        <div>
            <div class="jumbotron JY-my-banner JY-profile-banner">
                <!--p style="padding-top:50px;"><img :src="profile.headImg" alt="" style="width: 120px; height: 120px; border-radius: 60px; background-color: rgba(0,0,0,0.6); border: 3px solid #f2f2f2; display: inline-block;"></p>
                    <p style="font-size: 16px;">头像</p-->
            </div>
        </div>
        <section v-loading="showLoading">
            <div v-if="profile.User.Status==0" class="container">
                <div class="row">
                    <div class="col-lg-12 JY-about">
                        <h4>
                            <span>您的资质未认证，请前往认证……</span>
                        </h4>
                    </div>
                </div>
            </div>
            <div class="container pb-4">
                <div class="row">
                    <div class="col-lg-11" style="margin: 0 auto;">
                        <div class="row">
                            <div class="col-sm-12 JY-my-cont" style="padding-bottom: 20px; border-bottom: 1px solid #ddd;">
                                <p>
                                    <span style="font-size: 30px; padding-right: 10px;">{{profile.User.UserName}}</span>
                                    <span v-if="profile.User">- {{profile.User.UserType==0?'货主':(profile.User.UserType=='2'?'车主':(profile.User.UserType=='3'?'车主&司机':'司机'))}}</span>
                                    <span v-if="profile.User&&profile.User.Status!=0" class="tab">
                                <em></em>
                                {{profile.Type==-1?'企业':(profile.User&&profile.User.HuoZhuFenLei=='1'?'企业':'个人')}}
                              </span>
                                </p>
                                <p>
                                    <span v-if="profile.User.Mobile">手机：{{profile.User.Mobile}}</span>
                                    <span v-if="profile.User.ShenFenZheng">身份证号码：{{profile.User.ShenFenZheng}}</span>
                                    <span v-if="profile.ParentName">所属企业：{{profile.ParentName}}</span>
                                </p>
                                <div class="JY-goRZ">
                                    <a v-if="profile.User.Status==0" href="javascript:;" @click="gotoProfileMore">去认证</a>
                                    <a v-if="profile.User.Status==3" href="javascript:;" class="org">认证中</a>
                                    <a v-if="profile.User.Status==1" href="javascript:;" class="fin">已认证</a>
                                </div>
                            </div>
                            <div class="col-sm-12 JY-my-cont" style="padding-top: 30px;">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div v-if="profile.Cars&&profile.Cars.length!=0" class="JY-my-cont-list">
                                            <h2>车辆列表</h2>
                                            <a @click="gotoMyCar" style="float: right;margin-right: 10px;margin-top: -40px;" href="javascript:;">查看全部</a>
                                            <ul>
                                                <li v-for="item in profile.Cars" :key="item.AttID">
                                                    <a @click="openImg(domain+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID)">
                                                        <img :src="domain+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID">
                                                        <br> {{item.ChePaiHao}}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-if="profile.UserAtts&&profile.UserAtts.length!=0" class="JY-my-cont-list">
                                            <h2>我的认证</h2>
                                            <ul>
                                                <li v-for="item in profile.UserAtts" :key="item.AttID">
                                                    <a @click="openImg(domain+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID)">
                                                        <img :src="domain+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID">
                                                        <br> {{item.AttLabelName}}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div v-if="profile.Motorcade" class="col-sm-6">
                                        <h2>公司信息</h2>
                                        <p style="text-align: right; border-bottom: 1px solid #ddd;">
                                            <span class="sm-title">公司名称</span> {{profile.Motorcade.QiYeMingCheng||'-'}}
                                        </p>
                                        <p style="text-align: right; border-bottom: 1px solid #ddd;">
                                            <span class="sm-title">社会统一信用代码</span> {{profile.Motorcade.ZhengZhaoNo||'-'}}
                                        </p>
                                        <p style="text-align: right; border-bottom: 1px solid #ddd;">
                                            <span class="sm-title">法人代表</span> {{profile.Motorcade.FangRen||'-'}}
                                        </p>
                                        <p v-if="profile.Motorcade.TelPhone" style="text-align: right; border-bottom: 1px solid #ddd;">
                                            <span class="sm-title">公司电话</span> {{profile.Motorcade.FangRen||'-'}}
                                        </p>
                                        <p v-if="profile.Motorcade.BankCardID" style="text-align: right; border-bottom: 1px solid #ddd;">
                                            <span class="sm-title">开户行</span> {{profile.Motorcade.BankCardID||'-'}}
                                        </p>
                                        <p v-if="profile.Motorcade.BankCardNumber" style="text-align: right; border-bottom: 1px solid #ddd;">
                                            <span class="sm-title">银行卡号</span> {{profile.Motorcade.BankCardNumber||'-'}}
                                        </p>
                                        <p v-if="profile.Motorcade.YingYeQiXian" style="text-align: right; border-bottom: 1px solid #ddd;">
                                            <span class="sm-title">营业期限</span> {{profile.Motorcade.YingYeQiXian||'-'}}
                                        </p>
                                        <p style="text-align: right; border-bottom: 1px solid #ddd;">
                                            <span class="sm-title">注册地址</span> {{profile.Motorcade.Address||'-'}}
                                        </p>
                                        <p style="text-align: right; border-bottom: 1px solid #ddd;">
                                            <span class="sm-title">联系人</span> {{profile.Motorcade.Contact1||'-'}}
                                        </p>
                                        <p style="text-align: right; border-bottom: 1px solid #ddd;">
                                            <span class="sm-title">联系电话</span> {{profile.Motorcade.Contact1Phone||'-'}}
                                        </p>
                                        <p style="text-align: right; border-bottom: 1px solid #ddd;">
                                            <span class="sm-title">联系人邮箱</span> {{profile.Motorcade.Contact1Email||'-'}}
                                        </p>
                                        <p style="text-align: right; border-bottom: 1px solid #ddd;">
                                            <span class="sm-title">快递地址</span> {{profile.Motorcade.KuaiDiAddr||'-'}}
                                        </p>
                                        <div class="JY-my-cont-list" style="margin-top: 30px;">
                                            <h2>企业认证</h2>
                                            <ul>
                                                <li v-for="item in profile.MotorcadeAtts" :key="item.AttID">
                                                    <a @click="openImg(domain+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID)">
                                                        <img :src="domain+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID">
                                                        <br> {{item.AttLabelName}}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-dialog title="预览" :visible.sync="dialogVisible" width="80%">
                <img class="preview-img" :src="previewImg" alt>
            </el-dialog>
        </section>
    </div>
</template>
<script>
    import api from "../api";
    import util from "../libs/util";
    export default {
        data() {
            return {
                showLoading: false,
                domain: process.env.BASE_API,
                profile: {
                    Motorcade: {},
                    MotorcadeAtts: [],
                    User: {},
                    UserAtts: [],
                    Cars: [],
                    Type: 0
                },
                dialogVisible: false,
                previewImg: ""
            };
        },
        methods: {
            gotoProfileMore() {
                this.$router.push("/profilemore");
            },
            gotoMyCar(){
                this.$router.push("/mycars");
            },
            openImg(url) {
                this.previewImg = url;
                this.dialogVisible = true;
            },
            loadData() {
                let _this = this;
                _this.showLoading = true;
                api.getUserProfile().then(res => {
                    if (res.data.Succeed) {
                        _this.profile = res.data.Data;
                        if (_this.profile.Cars) {
                            let arr = util.arrayUnique(_this.profile.Cars, 'CarID');
                            _this.$set(_this.profile, "Cars", arr)
                        }
                    }
                    _this.showLoading = false;
                });
            },
        },
        mounted() {
            this.loadData();
        }
    };
</script>
<style scoped>
    .atts {
        width: 100px;
        height: 100px;
        background-color: rgba(0, 0, 0, 0.2);
        border: 1px solid #999;
        display: inline-block;
    }
    .preview-img {
        width: 100%;
    }
    .JY-my-cont-list ul img {
        object-fit: cover;
    }
</style>




// WEBPACK FOOTER //
// src/pages/Profile.vue